import { useNavigate } from 'react-router-dom';

const STORAGE_PENDING_URLS = 'checkoutPendingUrls';
const STORAGE_CURRENT_INDEX = 'checkoutCurrentIndex';

export default function CheckoutCancel() {
  const navigate = useNavigate();

  const handleBack = () => {
    sessionStorage.removeItem(STORAGE_PENDING_URLS);
    sessionStorage.removeItem(STORAGE_CURRENT_INDEX);
    navigate('/');
  };

  return (
    <div className="max-w-md mx-auto py-12 px-4 text-center">
      <div className="rounded-2xl bg-amber-100 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 p-8">
        <h1 className="text-2xl font-semibold text-amber-800 dark:text-amber-200 mb-4">
          Checkout cancelled
        </h1>
        <p className="text-lg text-amber-700 dark:text-amber-300 mb-6">
          You can continue shopping and checkout when ready.
        </p>
        <button
          type="button"
          onClick={handleBack}
          className="px-6 py-3 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 active:bg-indigo-800 transition-colors"
        >
          Back to home
        </button>
      </div>
    </div>
  );
}
